/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import PoaAgreementText from "../Common/PowerOfAttorney/PoaAgreementText";
import ButtonLoading from "../../Button/ButtonLoading";
import EmailVerificationModal from "../../FormInfoModal/EmailVerificationModal";
import { useForm } from "../../../provider/Form/FormProvider";
import applicationFormStyle from "../applicationFormStyle";
import Signature from "../Common/Signature/Signature";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type PowerOfAttorneyProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};
const PowerOfAttorney = ({ submitProps, product }: PowerOfAttorneyProps) => {
  const { handleSubmit } = useForm();

  return (
    <div>
      <Paper sx={applicationFormStyle.paper} elevation={4}>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm }} id={"application-form"} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={applicationFormStyle.subheadline}>
            Vollmacht
          </Typography>
          <div>
            <p>
              Hiermit erteile ich den Legalbird Rechtsanwälten (Legalbird Rechtsanwälte Rechtsanwalts GmbH) die Vollmacht zur Vertretung meiner Interessen in
              meiner Familienrechtsangelegenheit. Die Vollmacht umfasst insbesondere die Befugnis
            </p>
            <ol>
              <li>zur Antragstellung in Scheidungs- und Scheidungsfolgesachen</li>
              <li>zum Abschluss von Vereinbarungen über Ehescheidungsfolgen</li>
              <li>zur Stellung von Anträgen auf Erteilung von Renten- und sonstigen Versorgungsauskünften</li>
            </ol>
            <p>
              Die Vollmacht umfasst auch die Befugnis, die Vollmacht ganz oder teilweise auf andere zu übertragen und die von dem Gegner, von der Justizkasse
              oder von sonstigen Stellen zu erstattenden Beträge entgegenzunehmen sowie Akteneinsicht zu nehmen.
            </p>
            <p>
              Mir ist bekannt, dass mit der Vollmacht eine Beauftragung zur Scheidung und damit eine Anwaltsvergütung entsteht, deren Höhe abhängig vom
              Verfahrenswert ist, der vom Gericht festgesetzt wird.
            </p>
            <p>Die Bearbeitung meines Mandats erfolgt vorbehaltlich der Annahme durch die {product.lawFirm.name}.</p>
            <PoaAgreementText lawFirmName={product.lawFirm.name} />
          </div>
          <Signature product={product} person={product.client} />
          <Grid container justifyContent={"center"} alignItems={"baseline"}>
            <Grid item xs={12}>
              <ButtonLoading
                color="primary"
                variant="contained"
                type="submit"
                fullWidth={true}
                disabled={!product.client.signature}
                isLoading={submitProps.isLoading}
              >
                Vollmacht erteilen und kostenpflichtig beauftragen
              </ButtonLoading>
            </Grid>
          </Grid>
        </Box>
        <EmailVerificationModal />
      </Paper>
    </div>
  );
};

export default PowerOfAttorney;
